import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ca9a68de = () => interopDefault(import('..\\pages\\clinical-information.vue' /* webpackChunkName: "pages_clinical-information" */))
const _41530af9 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _53bb69e5 = () => interopDefault(import('..\\pages\\hcp-information.vue' /* webpackChunkName: "pages_hcp-information" */))
const _81ab45ac = () => interopDefault(import('..\\pages\\insurance-information.vue' /* webpackChunkName: "pages_insurance-information" */))
const _53c82d95 = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _5215a507 = () => interopDefault(import('..\\pages\\prescriber-attestation.vue' /* webpackChunkName: "pages_prescriber-attestation" */))
const _2137d5a6 = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _56eed0a3 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _01c062da = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _01ce7a5b = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _01eaa95d = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _01f8c0de = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _36a69e1b = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _04e6267a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/clinical-information",
    component: _ca9a68de,
    name: "clinical-information"
  }, {
    path: "/error",
    component: _41530af9,
    name: "error"
  }, {
    path: "/hcp-information",
    component: _53bb69e5,
    name: "hcp-information"
  }, {
    path: "/insurance-information",
    component: _81ab45ac,
    name: "insurance-information"
  }, {
    path: "/patient-information",
    component: _53c82d95,
    name: "patient-information"
  }, {
    path: "/prescriber-attestation",
    component: _5215a507,
    name: "prescriber-attestation"
  }, {
    path: "/thank-you",
    component: _2137d5a6,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _56eed0a3,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _01c062da,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _01ce7a5b,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _01eaa95d,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _01f8c0de,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _36a69e1b,
    name: "errors-500"
  }, {
    path: "/",
    component: _04e6267a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
